{
  "it": {
    "dashboard": {
      "greetings": {
        "afternoon": "Buon pomeriggio {first_name}",
        "evening": "Buonasera {first_name}",
        "morning": "Buongiorno {first_name}",
        "night": "Buonanotte {first_name}"
      },
      "milestones": {
        "action_title_decision": "Scelga {name}",
        "action_title_survey": "Compili {name}",
        "action_title_ticket": "Nuovo messaggio su {name}",
        "count_open": "{count} da fare",
        "journey_hide": "Nascondi il percorso del progetto",
        "journey_show": "Vedi il percorso del progetto",
        "journey_step_active": "In corso",
        "journey_step_completed": "Completata",
        "journey_step_planned": "Pianificata",
        "other_empty_subtitle": "{client} ti avvisa non appena c’è qualcosa per te.",
        "other_empty_title": "Sei aggiornato",
        "other_promoted_title": "Richiede la tua attenzione",
        "other_title": "Altre azioni",
        "stage_done_subtitle": "{client} ti avvisa quando arriva il passo successivo.",
        "stage_done_title": "Tutto fatto per questa fase",
        "stage_empty": "Al momento non c’è nulla da fare in questa fase.",
        "stage_eyebrow": "Fase attuale",
        "stage_final_subtitle": "Tutti i passaggi del tuo progetto sono conclusi. Ti teniamo aggiornato se cambia qualcosa.",
        "stage_final_title": "Hai finito del tutto",
        "stage_last": "Questa è l'ultima fase",
        "stage_next": "Prossima fase: {phase}",
        "stage_position": "Fase {current} di {total}",
        "stage_todo_title": "Per completare questa fase"
      },
      "titles": {
        "activityFeed": "Cronologia",
        "assignedTasks": "Le mie attività",
        "newsFeed": "Novità",
        "ongoingTickets": "In corso",
        "openTickets": "Aperte",
        "progress": "Avanzamento",
        "tickets": "Conversazioni",
        "totalTickets": "Tutte le conversazioni",
        "unreadTickets": "Non lette",
        "yourAssignedTickets": "Assegnate a Lei"
      }
    }
  }
}
